export var getTimeRange = function getTimeRange(timeRange) {
  var now = new Date();
  var start;
  switch (timeRange) {
    case 'past-day':
      start = new Date(now.getTime() - 24 * 60 * 60 * 1000); // 1 day
      break;
    case 'past-2-days':
      start = new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000); // 2 days
      break;
    case 'past-week':
      start = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000); // 1 week
      break;
    case 'past-month':
      start = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000); // 1 month
      break;
    case 'all':
      return {
        startTimestamp: null,
        endTimestamp: null
      };
    default:
      throw new Error('Invalid time range');
  }
  return {
    startTimestamp: start.toISOString(),
    endTimestamp: now.toISOString()
  };
};